module.exports = __webpack_public_path__ + "components/MapControl/svg/Inny obiekt przyrodniczy.svg?c5da17df";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Inny obiekt przyrodniczy.svg
// module id = 1936
// module chunks = 0